declare global {
  interface Window {
    dataLayer?: any[];
  }
}

type TrackingEvent = {
  category: string;
  action: string;
  label?: string;
};

const getDataLayer = () => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  return window.dataLayer;
};

export const trackEvent = ({ category, action, label }: TrackingEvent): void => {
  // note - need to handle when dataLayer not initialised - for dev
  getDataLayer().push({
    event: 'event',
    eventProps: {
      category,
      action,
      label
    }
  });
};

export const push = (...items: any[]) => getDataLayer().push(...items);
